import React from "react";
import { Switch, Route } from "react-router-dom";
import MultiDrop from "./Index";

export default () => (
  <Switch>
    <Route path="/multi_drop" component={MultiDrop} />
  </Switch>
);
